import LinkAPI, { onRequestEnterPrise, onGetRequestEnterPriseBody, onGetRequestEnterPriseBodyProvince } from './MainController';
import { getListHuyenEnter, getListXaEnter } from './Search'
import URL from './MainController';
import { store } from '../Redux/Store';
import Type from "../Redux/Type";
import { KinhTuyenTruc } from "./KinhTuyenTruc";
import { LocationDefault } from "./LocationDefault";
import { DSAPIQuyHoach } from "./APIQuyHoachTinh";
import setup from "./setup";

export function onAuthenticationEnterPrise(payload, temp, onSuccess) {
    let onProcessLogin = ({ statusCode, response }) => {
        if (statusCode === 200 && response.access_token) {
            localStorage.setItem(URL.tokenEnterPrise, response.access_token)
            onInfoByToken(response.access_token, onSuccess);
        } else {
            const err = {
                statusCode: 400,
                response: 'Sai thông tin đăng nhập hoặc mật khẩu'
            }
            onSuccess(err);
        }
    };
    onRequestEnterPrise(LinkAPI.loginEnterPrise, onProcessLogin, payload, '');
}

export function onInfoByToken(token, onSuccess) {
    let payload = new URLSearchParams();
    payload.append('access_token', token);

    let onProcessLogin = ({ statusCode, response }) => {
        if (statusCode === 200) {
            const userInfo = {
                Expired: null,
                FullName: response.name,
                Organization: null,
                Password: null,
                PhoneNumber: response.phone_number,
                Username: null,
            }
            store.dispatch({ type: Type.SET_TOKEN_ENTER, token: token });
            onGetProvince(token, userInfo, onSuccess)
        } else {
            localStorage.removeItem(URL.tokenEnterPrise);
            const err = {
                statusCode: 400,
                response: 'Đã có lỗi xã ra vui lòng thử lại sau'
            }
            onSuccess(err);
        }
    };
    onRequestEnterPrise(LinkAPI.getInfo, onProcessLogin, payload);
}

export function onGetProvince(token, userInfo, onSuccess) {
    //Thaydoi
    let onGetProvince = ({ statusCode, response }) => {
        if (statusCode === 200) {
            console.log('dsAPI: ', response)
            const apiLink = DSAPIQuyHoach ? DSAPIQuyHoach.filter(e => (e.key == response[0].matinh)) : null;
            userInfo = {
                ...userInfo,
                iddvhc: response[0].iddvhc,
                tendvhc: response[0].tendvhc,
                matinh: response[0].matinh,
                ktt: KinhTuyenTruc ? KinhTuyenTruc.filter(e => (e.key == response[0].matinh))[0].ktt : 0,
                // APILink: apiLink.length ? apiLink[0].APILink : ''
                // APILink: 'https://datdaiquangninhapi.vnpt.vn/api/'
                APILink: 'https://ilis-gateway.vnpt.vn/datdaiquocgia-api/api/'
            }
            console.log('onGetProvinceonGetProvince: ', userInfo)
            onGetDVHCHuyenXa(response[0].iddvhc, userInfo, onSuccess)
        } else {
            localStorage.removeItem(URL.tokenEnterPrise);
            const err = {
                statusCode: 403,
                response: 'Đã có lỗi xã ra vui lòng thử lại sau'
            }
            onSuccess(err);
        }
    };
    onGetRequestEnterPriseBodyProvince(LinkAPI.getProvice, onGetProvince, token);
}

export function onGetDVHCHuyenXa(iddvhc, userInfo, onSuccess) {

    let onSuccessHuyen = (statusCode, response) => {
        if (statusCode === 200 && response.length) {
            console.log('vaooo onGetDVHCHuyenXa: ', response)
            store.dispatch({ type: Type.SET_SEARCH, route: 'listDistrictEnter', value: response })

            const arrXa = [],
                lengthArr = response.length,
                arrHuyen = response;
            let tempt = 0;

            response.map(async (e) => {
                arrXa.push({
                    key: e.mahuyen,
                    mahuyen: e.mahuyen + 'TK',
                    text: 'Toàn Huyện/TX/TP',
                    latitude: null,
                    longitude: null,
                    iddvhc: e.iddvhc
                })
                let onSuccessLoadXa = (statusCode, response) => {
                    tempt = tempt + 1;
                    if (statusCode === 200) {
                        response = response.map((e, index) => {
                            let onProcessToaDo = (statusCodeToaDo) => {
                                if (statusCodeToaDo.statusCode === 200) {
                                    if (statusCodeToaDo.response && statusCodeToaDo.response.includes('(') && statusCodeToaDo.response.includes(')')) {
                                        let arrTempt = statusCodeToaDo.response.split('(');
                                        arrTempt = arrTempt[1].split(')');
                                        arrTempt = arrTempt[0].split(' ');

                                        arrXa.push({
                                            ...e,
                                            key: e.key,
                                            mahuyen: e.mahuyen ? parseInt(e.mahuyen) : e.mahuyen,
                                            text: e.tendvhc,
                                            latitude: parseFloat(arrTempt[1]),
                                            longitude: parseFloat(arrTempt[0]),
                                        })
                                        if (tempt == lengthArr) {
                                            store.dispatch({ type: Type.SET_SEARCH, route: 'listWardEnter', value: arrXa });

                                            const locationDefault = LocationDefault.filter(e => (e.key == userInfo.matinh))[0];
                                            let xaDefault = null, maHuyenTempt = null;
                                            if (locationDefault && arrXa) {
                                                xaDefault = arrXa ? (arrXa.filter(e => (e.maxa == locationDefault.maXa)) ? arrXa.filter(e => (e.maxa == locationDefault.maXa))[0] : 0) : 0;
                                                maHuyenTempt = locationDefault.maHuyen;
                                                userInfo = {
                                                    ...userInfo,
                                                    maHuyenDefault: maHuyenTempt ? parseInt(maHuyenTempt) : 0,
                                                    maXaDefault: locationDefault.maXa,
                                                    latDefault: xaDefault.latitude,
                                                    lngDefault: xaDefault.longitude,
                                                    dXS: locationDefault.dXS ? locationDefault.dXS : setup.dXSDefult,
                                                    dYS: locationDefault.dYS ? locationDefault.dYS : setup.dYSDefult
                                                }
                                            } else {
                                                maHuyenTempt = arrHuyen ? parseInt(arrHuyen[0].mahuyen) : 0;
                                                xaDefault = arrXa ? (arrXa.filter(e => (e.mahuyen == maHuyenTempt)) ? arrXa.filter(e => (e.mahuyen == maHuyenTempt))[0] : 0) : 0;
                                                userInfo = {
                                                    ...userInfo,
                                                    maHuyenDefault: maHuyenTempt,
                                                    maXaDefault: xaDefault.maxa,
                                                    latDefault: xaDefault.latitude,
                                                    lngDefault: xaDefault.longitude,
                                                    dXS: setup.dXSDefult,
                                                    dYS: setup.dYSDefult
                                                }
                                            }
                                            store.dispatch({ type: Type.SET_SEARCH, route: 'districtSelectedLocation', value: { key: parseInt(maHuyenTempt) } });
                                            store.dispatch({ type: Type.SET_SEARCH, route: 'districtSelectedLocationXa', value: xaDefault.maxa });
                                            store.dispatch({ type: Type.SET_SEARCH, route: 'districtSelectedEnter', value: { key: parseInt(maHuyenTempt) } });
                                            store.dispatch({ type: Type.SET_SEARCH, route: 'wardSelectedEnter', value: xaDefault });
                                            store.dispatch({ type: Type.SET_USER_INFO_ENTER, userInfo });
                                            onSuccess(statusCode, response);
                                        }

                                    }
                                }
                            };
                            onGetRequestEnterPriseBody(LinkAPI.getToaDo(e.maxa), onProcessToaDo);
                        });
                    }
                    else {
                        const err = {
                            statusCode: 405,
                            response: 'Đã có lỗi xã ra vui lòng thử lại sau'
                        }
                        onSuccess(err);
                    }
                };
                getListXaEnter(e.iddvhc, onSuccessLoadXa);

            });
        }
        else {
            localStorage.removeItem(URL.tokenEnterPrise);
            const err = {
                statusCode: 403,
                response: 'Đã có lỗi xã ra vui lòng thử lại sau'
            }
            onSuccess(err);
        }
    };
    getListHuyenEnter(onSuccessHuyen, iddvhc);
}
